// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-footer {
  background: #ffffff;
  border: 1px solid rgba(12, 20, 39, 0.06);
  box-shadow: 0 12px 30px rgba(12, 20, 39, 0.08);
  border-radius: 14px;
  padding: 12px 16px;
}
.footer-content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  margin: 0;
}
.footer-brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}
.footer-logo {
  height: 28px;
  border-radius: 8px;
  background: #eef2ff;
  padding: 4px;
}
.footer-title {
  font-weight: 700;
  color: #0f172a;
}
.footer-nav {
  display: inline-flex;
  gap: 12px;
}
.footer-nav a {
  color: #4b5563;
  text-decoration: none;
  font-weight: 600;
}
.footer-nav a:hover {
  color: #1d4ed8;
}
.footer-legal {
  display: grid;
  gap: 2px;
  font-size: 12px;
  color: #6b7280;
}
`, "",{"version":3,"sources":["webpack://./projects/admin/src/components/core/footer/footer.component.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,8CAA8C;EAC9C,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,SAAS;AACX;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,cAAc;AAChB","sourcesContent":[".admin-footer {\n  background: #ffffff;\n  border: 1px solid rgba(12, 20, 39, 0.06);\n  box-shadow: 0 12px 30px rgba(12, 20, 39, 0.08);\n  border-radius: 14px;\n  padding: 12px 16px;\n}\n.footer-content {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  width: 100%;\n  margin: 0;\n}\n.footer-brand {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n}\n.footer-logo {\n  height: 28px;\n  border-radius: 8px;\n  background: #eef2ff;\n  padding: 4px;\n}\n.footer-title {\n  font-weight: 700;\n  color: #0f172a;\n}\n.footer-nav {\n  display: inline-flex;\n  gap: 12px;\n}\n.footer-nav a {\n  color: #4b5563;\n  text-decoration: none;\n  font-weight: 600;\n}\n.footer-nav a:hover {\n  color: #1d4ed8;\n}\n.footer-legal {\n  display: grid;\n  gap: 2px;\n  font-size: 12px;\n  color: #6b7280;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
